import type { Locale } from '@core/Entities/Locale/Locale.entity';
import { mappedLocales } from '@core/Utils/Intl/MappedLocales';

/* eslint-disable no-param-reassign */
export const inputMask = (mask: string, value: string, locale: Locale) => {
  if (mask === 'currency') {
    const num = typeof value === 'number' ? String(value) : value;

    const plainNumber = Number(num.replace(/[^\d]/g, ''));

    return plainNumber.toLocaleString(mappedLocales[locale]);
  }

  return value;
};
